import React from 'react';
import { SponsorsGrid } from '../components/SponsorBanner';
import { Handshake } from 'lucide-react';

export default function Sponsors() {
  return (
    <div className="min-h-screen bg-muted/30 py-12" data-testid="sponsors-page">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/10 mb-4">
            <Handshake className="w-8 h-8 text-accent" />
          </div>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
            Nuestros Patrocinadores
          </h1>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Conoce las soluciones de seguridad y tecnología de nuestros socios estratégicos. 
            Empresas líderes que comparten nuestra visión de seguridad avanzada.
          </p>
        </div>

        {/* Sponsors Grid */}
        <SponsorsGrid />

        {/* CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-2xl p-8 max-w-2xl mx-auto">
            <h2 className="text-xl font-semibold text-foreground mb-3">
              ¿Quieres ser patrocinador?
            </h2>
            <p className="text-muted-foreground mb-4">
              Únete a nuestra red de socios y llega a miles de profesionales de seguridad.
            </p>
            <a 
              href="/contact" 
              className="inline-flex items-center gap-2 bg-accent text-white px-6 py-2.5 rounded-lg font-medium hover:bg-accent/90 transition-colors"
            >
              Contáctanos
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
